var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdpRecommended(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 32,
    rx: 15,
    fill: "#FFEEC5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2493_8307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0846 15.416L14.418 10.166C14.8821 10.166 15.3272 10.3504 15.6554 10.6786C15.9836 11.0068 16.168 11.4519 16.168 11.916V14.2493H19.4696C19.6387 14.2474 19.8063 14.2823 19.9606 14.3516C20.1148 14.4208 20.2522 14.5228 20.3632 14.6504C20.4742 14.778 20.5561 14.9282 20.6033 15.0907C20.6504 15.2531 20.6617 15.4238 20.6363 15.591L19.8313 20.841C19.7891 21.1192 19.6478 21.3728 19.4334 21.555C19.219 21.7373 18.946 21.8359 18.6646 21.8327H12.0846M12.0846 15.416V21.8327M12.0846 15.416H10.3346C10.0252 15.416 9.72847 15.5389 9.50968 15.7577C9.29089 15.9765 9.16797 16.2733 9.16797 16.5827V20.666C9.16797 20.9754 9.29089 21.2722 9.50968 21.491C9.72847 21.7098 10.0252 21.8327 10.3346 21.8327H12.0846",
    stroke: "#A14D00",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2493_8307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(8 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdpRecommended);
export default __webpack_public_path__ + "static/media/mdp-recommended.fc71251c9c308174201b20c085993d01.svg";
export { ForwardRef as ReactComponent };